import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

interface IWeeklyProjectHighlightDocPreviewerProps extends IBaseProps {
  // 预览文档的cos的存储的key
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  project_id?: string | number; // Project ID for scroll restoration
  content_id?: string | number; // Content ID (optional, for future fine-grained scrolling)
}

// Require login to view documents (ensures watermark is always applied)
const getAuth = async (): Promise<boolean> => {
  const userName = sessionStorage.getItem('userName');
  // Only allow access if user is logged in (has userName)
  return !!userName;
};

const WeeklyProjectHighlightDocPreviewer: React.FC<IWeeklyProjectHighlightDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    doc_key: docKey,
    doc_name: docName = '',
    doc_suffix: docSuffix = '',
    project_id: projectId,
    content_id: contentId,
  } = props;

  const handleNavigatorClick = () => {
    // Store the project ID for scroll restoration
    if (projectId) {
      storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.WEEKLY_PROJECT_HIGHLIGHT_PROJECT_ID, String(projectId));
    }
    // Navigate back to the weekly project highlight page
    history.replace('/strategic/home?tab=business&subtitle=executiveSummary');
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  // Path for this previewer type
  const cosPath = 'weekly_project_highlight';

  return (
    <div style={style} className={classnames('dbs-weekly-project-highlight-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="Back to Weekly Project Highlight" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default WeeklyProjectHighlightDocPreviewer;

